import { render } from "./SiteProduct.vue?vue&type=template&id=315e8fd4&ts=true"
import script from "./SiteProduct.vue?vue&type=script&lang=ts"
export * from "./SiteProduct.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__